import controller from './controller';
import template from './template.html';

const controllerAs = 'courseAccessCtrl';
const bindings = {
  access: '=',
  inviteOnly: '=',
  firmOnly: '=',
  registrationAccess: '='
};

export default {
  template,
  controller,
  controllerAs,
  bindings
};



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/courseAccessEditor/index.js